// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';
// import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyBhnjtE7a-occLVMJODiWJdOZ5mKvA0xaQ",
  authDomain: "vigor-25ba3.firebaseapp.com",
  projectId: "vigor-25ba3",
  storageBucket: "vigor-25ba3.firebasestorage.app",
  messagingSenderId: "653864555385",
  appId: "1:653864555385:web:a790de48354e415d6b15a8",
  measurementId: "G-HBFVV6Z0X0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// const analytics = getAnalytics(app);
export const auth=getAuth(app);

export const messaging = getMessaging(app);

export default app;
